module.exports = __webpack_public_path__ + "static/media/color_fondo2.dc4ace81.png";